import { render, staticRenderFns } from "./AcceleratorPc.vue?vue&type=template&id=0a41c9c9&scoped=true&"
import script from "./AcceleratorPc.vue?vue&type=script&lang=js&"
export * from "./AcceleratorPc.vue?vue&type=script&lang=js&"
import style0 from "./AcceleratorPc.vue?vue&type=style&index=0&id=0a41c9c9&prod&scoped=true&lang=scss&"
import style1 from "./AcceleratorPc.vue?vue&type=style&index=1&id=0a41c9c9&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a41c9c9",
  null
  
)

export default component.exports